import { REGEXPS } from '@/base/const/regexp.const'
import { MESSAGES } from '@/base/const/texts.const'

export const EMAIL_VALIDATOR = (rule, value, callback) => {
  if (!value) {
    callback(new Error(MESSAGES().validators.emailRequired))
  } else if (!(REGEXPS.emailValidator.test(value))) {
    callback(new Error(MESSAGES().validators.emailNotValid))
  } else {
    callback()
  }
}

export const FUSE_OPTIONS = {
  threshold: 0.2, // umiarkowana czułość na błędy
  distance: 50, // szukaj bliskich dopasowań
  ignoreLocation: true, // ignoruj pozycję błędu w stringu
  includeScore: true
}

export const FUSE_VALID_EMAIL_DOMAINS_LIST = [
  'gmail.com',
  'hotmail.com',
  'outlook.com',
  'msn.com',
  'wp.pl',
  'onet.pl',
  'interia.pl',
  'o2.pl',
  'yahoo.com',
  'icloud.com',
  'protonmail.com',
  'mail.com',
  'aol.com',
  'live.com',
  'googlemail.com',
  'edu.pl',
  'gov.pl',
  'posteo.de',
  't-online.de',
  'gmx.de',
  'fastmail.com',
  'zoho.com',
  'naver.com',
  'mail.ru',
  'ya.ru'
]
